import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { getEstimaPrefillParameters } from '@aviv_price-pages/brand';
import { Box } from '@gemini/core';
import { ObfuscatedButtonLink } from 'src/components/ObfuscatedButtonLink';
import { MediumCta } from '@/entities/enums/MediumCta';
import { MediumDestination } from '@/entities/enums/MediumDestination';
import { getMediumAttribute } from '@/helpers/tracking/tracking';
import { usePageLayoutContext } from '@/hooks/usePageLayoutContext/usePageLayoutContext';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
export const EstimateBlock = () => {
    const { pricePageProps: { pricePageContext }, } = usePageLayoutContext();
    const [estimaLinkUrl, setEstimaLinkUrl] = useState(process.env.ESTIMATION_FUNNEL_URL);
    const { t } = useShellTranslation();
    useEffect(() => {
        setEstimaLinkUrl(`${process.env.ESTIMATION_FUNNEL_URL}?m=${getMediumAttribute(MediumCta.ESTIMATE, pricePageContext.place.type, MediumDestination.ESTIMATE_STEP1)}${getEstimaPrefillParameters(pricePageContext.place)}`);
    }, [pricePageContext.place]);
    return (_jsx(Box, { textAlign: "center", children: _jsx(ObfuscatedButtonLink, { isExternal: true, href: estimaLinkUrl, isFullWidth: true, children: t('estimation_block.button') }) }));
};
